const rootPx = 16;

const px2rem = (value: number): string => {
  return `${(value / rootPx).toFixed(2)}rem`;
};

export default px2rem;
